(() => {
  // src/ticker.ts
  (() => {
    const setupTicker = (ticker) => {
      const track = ticker.querySelector(".ticker__track");
      const sourceGroup = track == null ? void 0 : track.querySelector(".ticker__group");
      if (!track || !sourceGroup) return;
      const fit = () => {
        Array.from(track.querySelectorAll(".ticker__group")).slice(1).forEach((g) => g.remove());
        const groupWidth = sourceGroup.offsetWidth;
        if (groupWidth === 0) return;
        let guard = 0;
        while (track.scrollWidth < ticker.clientWidth + groupWidth && guard++ < 50) {
          const clone = sourceGroup.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          track.appendChild(clone);
        }
        track.style.setProperty("--ticker-translate", `-${groupWidth}px`);
      };
      fit();
      const controller = new AbortController();
      const { signal } = controller;
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(fit, 150);
      }, { signal });
      const observer = new IntersectionObserver(([entry]) => {
        ticker.classList.toggle("ticker--paused", !entry.isIntersecting);
      });
      observer.observe(ticker);
      document.addEventListener("shopify:section:unload", (e) => {
        if (!e.target.contains(ticker)) return;
        clearTimeout(resizeTimer);
        controller.abort();
        observer.disconnect();
      }, { signal });
    };
    const initTickers = () => {
      document.querySelectorAll(".ticker:not([data-ticker-init])").forEach((ticker) => {
        ticker.dataset.tickerInit = "1";
        setupTicker(ticker);
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initTickers);
    } else {
      initTickers();
    }
    document.addEventListener("shopify:section:load", (e) => {
      e.target.querySelectorAll(".ticker[data-ticker-init]").forEach((ticker) => {
        delete ticker.dataset.tickerInit;
      });
      initTickers();
    });
  })();
})();
